import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import {
  getAuthorizationUsers,
  getAuthorizationGroups,
  getAuthorizationUpdatingUser,
  isAuthorizationUpdatingUser,
} from '../../../reducers/analyticsApp';
import UsersModal from '../../../components/authorization/users/UsersModal';
import {
  cancelUpdateUser,
  setUserGroups,
  setUserId,
  setUserPermissions,
  updateUser,
} from '../../../actions/authorization';
import { setErrorMessage } from '../../../actions/application';
import { getNotUniqUserMessage } from '../../../utils/errors';
import { sortByFields } from '../../../components/authorization/sort';
import { groupBy } from '../../../utils/collection';

const prepareDataSource = (groups) => {
  const tempGroups = [...groups].map((group) => ({ ...group, key: group.groupId }));
  const separatedArr = groupBy(
    tempGroups,
    (item) => (/^[a-z]/i.test(item.groupId) ? 'startsWithoutSymbol' : 'startsWithSymbol'),
    { startsWithoutSymbol: [], startsWithSymbol: [] }
  );

  sortByFields(separatedArr.startsWithoutSymbol, 'groupId');
  sortByFields(separatedArr.startsWithSymbol, 'groupId');

  return separatedArr.startsWithoutSymbol.concat(separatedArr.startsWithSymbol);
};

const mapStateToProps = (state) => ({
  user: getAuthorizationUpdatingUser(state),
  users: getAuthorizationUsers(state),
  groups: createSelector(
    (s) => getAuthorizationGroups(s),
    (arr) => prepareDataSource(arr)
  )(state),
  updating: isAuthorizationUpdatingUser(state),
});

const mapDispatchToProps = {
  onClose: cancelUpdateUser,
  onOk: updateUser,
  onUserIdChange: setUserId,
  onUserPermissionsChange: setUserPermissions,
  onUserGroupsChange: setUserGroups,
  setErrorMessage,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onOk: () => {
    const isUserUniq = (stateProps.users || [])
      .filter(({ uuid }) => uuid !== stateProps.user.uuid)
      .every(({ userId }) => userId !== stateProps.user.userId);

    if (isUserUniq) {
      dispatchProps.onOk(stateProps.user);
    } else {
      const notUniqErrorMessage = getNotUniqUserMessage(stateProps.user?.userId);
      dispatchProps.setErrorMessage(notUniqErrorMessage);
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UsersModal);
